var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M8.5001 9.68999C12.7251 9.68999 16.1501 7.80623 16.1501 5.48249C16.1501 3.15876 12.7251 1.27499 8.5001 1.27499C4.27512 1.27499 0.850098 3.15876 0.850098 5.48249C0.850098 7.80623 4.27512 9.68999 8.5001 9.68999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.976237 7.7775C1.63032 9.73599 4.75011 11.22 8.5001 11.22C12.2501 11.22 15.3699 9.73599 16.024 7.7775C16.1068 8.02557 16.1501 8.28125 16.1501 8.5425C16.1501 10.8662 12.7251 12.75 8.5001 12.75C4.27512 12.75 0.850098 10.8662 0.850098 8.5425C0.850098 8.28125 0.893387 8.02557 0.976237 7.7775Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.976237 10.8375C1.63032 12.796 4.75011 14.28 8.5001 14.28C12.2501 14.28 15.3699 12.796 16.024 10.8375C16.1068 11.0856 16.1501 11.3412 16.1501 11.6025C16.1501 13.9262 12.7251 15.81 8.5001 15.81C4.27512 15.81 0.850098 13.9262 0.850098 11.6025C0.850098 11.3412 0.893387 11.0856 0.976237 10.8375Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame50);
export default __webpack_public_path__ + "static/media/Frame (50).28e7d55bbe641e9ef67dc54feb0a1be6.svg";
export { ForwardRef as ReactComponent };